import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";

import { useStoreLocator } from "../../../../hooks/use-store-locator";
import { StoreDetail, StoreDetailProps } from "./store-detail";
import { StoresListBody, StoresListBodyProps } from "./stores-list-body";
import { StoresListHeader, StoresListHeaderProps } from "./stores-list-header";

export interface StoreLocatorPanelProps {
  stores: Queries.CompanySiteDetailDataFragment[];
  labels: StoresListBodyProps["labels"] &
    StoresListHeaderProps["labels"] &
    StoreDetailProps["labels"];
  className?: string;
}

export function StoreLocatorPanel({ className, labels, ...rest }: StoreLocatorPanelProps) {
  const { selectedStore, setSelectedStoreId } = useStoreLocator();
  return (
    <div className={clsx("flex gap-3", className)}>
      <div
        className={clsx(
          "bg-neutral-light rounded-xl overflow-hidden flex flex-col gap-2 w-72",
          className
        )}
      >
        <StoresListHeader labels={labels} />
        <StoresListBody className="shadow-lg" labels={labels} {...rest} />
      </div>
      <AnimatePresence mode="wait">
        {selectedStore && (
          <motion.div
            key={selectedStore.id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 100 }}
            exit={{ opacity: 0 }}
          >
            <StoreDetail
              className="w-72 h-fit shadow-lg"
              labels={labels}
              store={selectedStore}
              onClose={() => setSelectedStoreId(null)}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
